export const DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST = "DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST";
export const DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS = "DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS";
export const DIARY_SLOT_ASSIGNEE_SEARCH_FAIL    = "DIARY_SLOT_ASSIGNEE_SEARCH_FAIL";
